import { CommonModule } from "@angular/common";
import { Component, Inject, Input } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { select, Store } from "@ngrx/store";
import { AppState } from "../../../../app.state";
import { ConfirmDialogComponent } from "../../../../confirm-dialog/confirm-dialog.component";
import { LoadingService } from "../../../../loading/loading.service";
import { AcuerdosService } from "../../../../services/acuerdos/acuerdos.service";
import { cargarDatosGuardados } from "../../../../states/forms/actions";
import { selectUsuario } from "../../../../states/usuario/selector";
import { stripHtml } from "../../detalle-tema/dtoDetalleTema";

@Component({
  selector: "app-quitar-tema",
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  templateUrl: "./terminar-tema.component.html",
  styleUrl: "./terminar-tema.component.css",
})
export class TerminarTemaAMrbComponent {
  @Input() tema!: any;
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  constructor(
    private store: Store<AppState>,
    public dialogRef: MatDialogRef<TerminarTemaAMrbComponent>,
    public dialog: MatDialog,
    public loadingService: LoadingService,
    public acuerdosService: AcuerdosService,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {}
  ngOnInit(): void {}

  async terminarTemaMrb() {
    console.log("this data", this.data);

    this.loadingService.show();
    this.dialogRef.close();
    const user = structuredClone(this.stateUser.state().usuario);

    const tema = {
      id_tema: this.data.idTema,
      justificacionTema: "",
      id_usuario: user.uid,
      entradas: this.data.justificacion.entradas,
      entregables: this.data.justificacion.entregables,
      usuario: user.nombre,
    };

    const notificacion = {
      nombreUsuario: user.nombre,
      fechaAcuerdo: this.data.acuerdoActual.fechaAcuerdo,
      nombreTema: this.data.nombreTema,
      descripcionTema: stripHtml(this.data.descripcionTema),
      id_categorizacion: this.data.id_categorizacion,
      notificacion: "temaTerminado",
    };

    try {
      const terminarTema = await this.acuerdosService.terminarTemaAcuerdo(tema);
      const notificarTema =
        await this.acuerdosService.notificacionTerminarTemaAcuerdo(
          notificacion
        );

      if (!terminarTema.error && !notificarTema.error) {
        this.loadingService.hide();
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
          width: "450px",
          data: {
            title: "Éxito",
            message: "El tema ha sido terminado",
            showButtons: {
              accept: true,
              cancel: false,
            },
            direction: "end",
            buttonsName: {
              cancel: "CANCELAR",
              accept: "CERRAR",
            },
          },
          disableClose: true,
        });

        dialogRef.componentInstance.confirmAction.subscribe(() => {
          this.loadingService.hide();
          this.store.dispatch(
            cargarDatosGuardados({ temas: [{ ...this.data }] })
          );
        });

        dialogRef.componentInstance.cancelAction.subscribe(() => {
          this.loadingService.hide();
          this.store.dispatch(
            cargarDatosGuardados({ temas: [{ ...this.data }] })
          );
        });
      }
    } catch (error) {
      this.loadingService.hide();
    }
  }
}
